/**************************************************
 * Nombre:       Formulario_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    CategoryOutlined,
    CoffeeMakerOutlined,
    FastfoodOutlined,
    MoneyOutlined,
    QrCodeOutlined,
    ScaleOutlined,
    WarehouseOutlined
} from "@mui/icons-material";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoSelectPropId from "../../Modulo_formularios/Componentes/IngresoSelectPropId";

const Formulario_Producto = ({...props}) => {
    const [categorias, setCategorias] = useState([])
    const [zonas, setZonas] = useState([])
    const [inventario, setInventario] = useState([])

    useEffect(() => {
        obtenerCol('categorias').then((categorias) => {
            setCategorias(categorias.data)
        })
        obtenerCol('zonas').then((zon) => {
            setZonas(zon.data)
        })
        obtenerCol('inventarios').then((zon) => {
            setInventario(zon.data)
        })
    }, []);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagenCrop dato={'img'} {...props}
                                       requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={FastfoodOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>


                <Grid container size={6}>
                    <IngresoSelect Icono={CategoryOutlined} nombre={'Categoria'} dato={'categorias'} {...props}
                                   requerido={'Campo requerido'} opciones={categorias.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={QrCodeOutlined} nombre={'Codigo'} dato={'codigo'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={CoffeeMakerOutlined} nombre={'Zona Produccion'} dato={'zona'} {...props}
                                   requerido={'Campo requerido'} opciones={zonas.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={MoneyOutlined} nombre={'Valor'} dato={'valor'} {...props}
                                   requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 1}}>
                    <Typography>Producto que se usa de inventario</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoSelectPropId Icono={WarehouseOutlined} nombre={'Producto de Inventario'}
                                         dato={'productoInventario'} {...props}
                                         opciones={inventario} datoId={'idInventario'} propiedad={'nombre'}
                                         propiedadId={'id'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={ScaleOutlined} nombre={'Cantidad'} dato={'cantidadInventario'} {...props}/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Producto